var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1756.13 882.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 441.35,
    x2: 1756.13,
    y2: 441.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1756.13,827.51v55.17l-206.89.02c1.51-116.79-29.7-236.26-89.43-336.24l179.17-103.56c64.39,114.81,107.63,243.81,113.56,376.29l3.6,8.33ZM295.85,546.46l-176.97-104.73C40.44,574.26-.19,728.29,0,882.67h206.88c-1.69-116.97,30.08-235.62,88.98-336.22ZM1382.79,161.29c-9.82-6.89-64.52-45.12-71.17-40.37l-100.21,173.89c91.2,56.89,171.25,127.92,229.16,219.26l181.08-96.92c-58.42-98.11-145.32-190.23-238.86-255.86ZM381.63,155.79c-97.06,65.99-187.12,160.7-247.15,261.36l177.64,99.61c60.21-89.06,136.32-164.07,229.42-218.44l-97.03-177.4c-6-4.3-53.91,28.77-62.88,34.87ZM469.02,105.13l102.08,174.44c93.39-41.28,190.78-72.61,294.33-72.7V0c-137.68,4.5-276.8,36.33-396.41,105.13ZM890.7,206.88c102.9.29,201.71,30.75,294.33,72.69l102.08-174.44C1167.57,36.07,1028.27,4.64,890.7,0v206.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementBar);
export default __webpack_public_path__ + "static/media/Engagement Bar.d5fd1bb001d2c30de0e69c14117120db.svg";
export { ForwardRef as ReactComponent };